export const RESHOP_SUCCESS_TITLE =
  "Your room selection has been successfully updated";
export const RESHOP_SUCCESS_SUBTITLE =
  "Take a moment to review your new trip details and total before finishing your booking.";
